// extracted by mini-css-extract-plugin
export default {"container":"styles_container__G9uvA","content":"styles_content__ir-xE","field_container":"styles_field_container__xbT1f","title":"styles_title__js0-f"};